import React from 'react';
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

export class MyobOnboarding extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const businessId = urlParams.get('businessId');
    const businessName = urlParams.get('businessName');
    if (!code) {
      this.props.history.push("/settings/myob")
    }
    else {
      // businessId (the Company File GUID) comes back on the OAuth redirect itself
      // (requires prompt=consent) - the old /myob/companyfiles picker no longer works.
      if (businessId) {
        this.setState({
          businessId: businessId,
          businessName: businessName,
          cfURI: 'https://api.myob.com/accountright/' + businessId
        })
      }
      this.getToken(code);
    }
  }

  state = {
    statusView: 'CompanyFile',
    importDone: false,
    isReconnect: false,
    settings: {},
    businessId: '',
    businessName: '',
    cfURI: '',
    refreshToken: ''
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  getToken = async (code) => {
    var decodeCode = decodeURI(code);
    let requestParams = {
      'code': decodeCode
    }
    axios.post('/myob/auth/token', requestParams)
        .then(data => {
            this.setState({refreshToken: data.token})
            this.fetchSupplierData();
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to exchange code for token')
        })
  }

  fetchSupplierData = async () => {
    axios.get('/user')
        .then(data => {
          var settings = JSON.parse(data[0].settings)
          // A supplier already had MYOB set up (categories/price lists/import already
          // done) if their existing integration was already type 'myob' - this is a
          // reconnect, not a first-time setup, so /myob/import must not run again.
          var isReconnect = !!(settings.integration && settings.integration.type === 'myob')
          this.setState({
            settings: settings,
            isReconnect: isReconnect
          });
          // Save token
          this.updateSettings()
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to fetch user data')
        })
  }

  updateSettings = async () => {
    let settings = this.state.settings
    let integration = settings.integration || {}
    integration.type = 'myob'
    integration.enabled = true
    integration.cfURI = this.state.cfURI
    integration.businessId = this.state.businessId
    integration.businessName = this.state.businessName
    integration.refreshToken = this.state.refreshToken
    integration.scopeMigratedAt = new Date().toISOString()
    settings.integration = integration
    let requestParams = {
      'settings': settings
    }
    axios.post('/user/update/settings', requestParams)
        .then(data => {
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error("Error: Could not save settings!");
        })
  }

  importData = async () => {
    toast.warning('Syncing Data...please wait', {autoClose: false})
    axios.get('/myob/import')
        .then(data => {
          this.setState({
            importDone: true
          });
          toast.dismiss()
        })
        .catch (err => {
          toast.dismiss()
          console.error(err);
          Rollbar.error(err)
          toast.error("Error: Could not import data!");
        })
  }

    render() {
        return (
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center onboarding-logo-section">
                <h4>Setup MYOB Integration</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.state.statusView === 'CompanyFile' ? (
                <div className="modal-dialog allow-click">
                  <div className="modal-content">
                    <div className="modal-header text-center">
                      <h4 className="modal-title ">Company File</h4>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label>Company File</label>
                        <p className="form-control-static">{this.state.businessName || 'Connecting...'}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row pad-top">
                    <div className="col-md-6 text-left"><button type="button" className="btn btn-primary" disabled>Previous</button></div>
                    <div className="col-md-6 text-right">
                      <button type="button" className={this.state.cfURI ? "btn btn-primary" : "btn btn-primary disabled"}
                        onClick={() => this.state.isReconnect ? this.props.history.push("/settings/myob") : this.setState({statusView: 'Import'})}>
                        {this.state.isReconnect ? 'Finish' : 'Next'}
                      </button>
                    </div>
                  </div>
                </div>) : null }
                {this.state.statusView === 'Import' ? (
                <div className="modal-dialog allow-click">
                  <div className="modal-content">
                    <div className="modal-header text-center">
                      <h4 className="modal-title ">Import MYOB Data</h4>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label>Import Products/Price Lists</label>
                        <div>
                          <button type="button" className="btn btn-warning" disabled={this.state.importDone} onClick={() => this.importData()}>Start</button>
                        </div>
                        <small className="form-text text-muted">
                          This will import all active and inventoried products and their associated price matrix levels. Customers can be selected and imported individually on the Customers page after this.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="row pad-top">
                    <div className="col-md-6 text-left"><button type="button" className="btn btn-primary" onClick={() => this.setState({ statusView: 'CompanyFile' })} >Previous</button></div>
                    <div className="col-md-6 text-right"><button type="button" className={this.state.importDone ? "btn btn-primary" : "btn btn-primary disabled"} onClick={() => this.props.history.push("/settings/myob")}>Finish</button></div>
                  </div>
                </div>) : null }
              </div>
            </div>
          </div>
        );
    }
}
